 
import React, { useEffect, useRef } from 'react';
import app from "./app"
import { GridWrap, ListWrap, Elements } from "./helpers"


export const HomeFeaturesList = function ({ data, index, widgetType, mode, device }) {
    // console.log("home_features_list", data) 
    let listitem = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap className={'h-auto'} data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <Elements row={v.icon} id={"icon"} device={device} mode={mode} />
                    <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.gallery} className="h-auto" mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className='row'>
            <div className='col'>
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
            </div>
        </div>
        <div className={data.properties.isFlipped ? `row flex-md-row-reverse flex-column-reverse` : `row`}>
            <div className='col-12 col-lg-4'><Elements row={data.elements.banner} id={"banner"} device={device} mode={mode} /> </div>
            <div className='col-12 col-lg-8'>
                {listitem}
            </div>
        </div>
        <div className='row'>
            <Elements row={data.elements.description} id={"description"} device={device} />
            <div className={`${app.isButton(data.elements.primaryButton, device)} ${app.isButton(data.elements.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                <Elements row={data.elements.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
            </div>
        </div>
    </div>
}

export const HomeSocialBanner = function ({ data, index, widgetType, mode, device }) {
    // console.log("home_social_banner", data) 
    let listitem = ""
    if (data.elements.swiper) {
        if (data.elements.swiper.items) {
            listitem = data.elements.swiper.items.map(function (v, i) {
                return <GridWrap swiper={data.elements.swiper.properties.isSwiper} data={v} key={'key-' + v.viewId + i} id="swiper" mode={mode} device={device}>
                    <div className={v.properties.isFlipped ? `row flex-md-row-reverse flex-column-reverse` : `row`}>
                        <div className="col-12 col-md-7 d-flex align-items-center">
                            <div className='mw-100'>
                                <Elements row={v.headingLabel} id={"headingLabel"} device={device} mode={mode} />
                                <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                                <Elements row={v.summary} id={"summary"} device={device} mode={mode} />

                                <div className={`${app.isButton(v.primaryButton, device)} ${app.isButton(v.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                                    <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                                    <Elements row={v.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                                </div>
                                <div className={`mb-2 d-flex social_btn_wrap justify-content-${data.properties.itemAlignment}`}>
                                    <Elements row={v.googleplay} id={"googleplay"} device={device} classType="me-3" mode={mode} />
                                    <Elements row={v.appstore} id={"appstore"} device={device} mode={mode} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-5">
                            <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                        </div>
                    </div>
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.swiper} className="h-auto" mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <Elements row={data.elements.description} id={"description"} device={device} mode={mode} />
            </div>
        </div>
        {listitem}
    </div>
}

export const HomeSlider = function ({ data, index, widgetType, mode, device }) {
    // console.log("HomeSlider", data)
    let listitem = ""
    if (data.elements.swiper) {
        if (data.elements.swiper.items) {
            listitem = data.elements.swiper.items.map(function (v, i) {
                return <GridWrap swiper={data.elements.swiper.properties.isSwiper} data={v} key={'key-' + v.viewId + i} id="swiper" mode={mode} device={device}>
                    <div className="row">
                        <div className="col-12">
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                            <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                            <div className={`${app.isButton(v.primaryButton, device)} ${app.isButton(v.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                                <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                                <Elements row={v.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                            </div>
                        </div>
                        <div className="col-12">
                            <Elements row={v.banner} id={"banner"} device={device} />
                        </div>
                        <div className="col-12">
                            <Elements row={v.footerSummary} id={"footerSummary"} device={device} />
                        </div>
                    </div>
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.swiper} grid={false} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        {listitem}
    </div>
}


export const HomeIntroductionFour = function ({ data, index, widgetType, mode, device }) {
    // console.log("HomeIntroductionFour", data) 
    let listitem = ""
    if (data.elements.swiper) {
        if (data.elements.swiper.items) {
            listitem = data.elements.swiper.items.map(function (v, i) {
                return <GridWrap swiper={data.elements.swiper.properties.isSwiper} className="d-flex align-items-center justify-content-center"  data={v} key={'key-' + v.viewId + i} id="swiper" mode={mode} device={device}>
                    <div className="row mw-100">
                        <div className="col-12 col-md-12">
                            <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                            <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                            <Elements row={v.description} id={"description"} device={device} mode={mode} />
                            <Elements row={v.subDescription} id={"subDescription"} device={device} mode={mode} />
                            <div className={`${app.isButton(v.primaryButton, device)} ${app.isButton(v.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                                <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                                <Elements row={v.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                            </div>
                        </div>
                    </div>
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.swiper} className="auto" grid={false} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        {listitem}
    </div>
}


export const HomeProductGallery = function ({ data, index, widgetType, mode, device }) {
    // console.log("HomeProductGallery", data)
    let listitem = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap className="position-relative d-flex my-1 py-1" data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <Elements row={v.banner} id={"banner"} device={device} classType="w-auto" mode={mode} />
                    <div className="d-flex position-relative py-2 w-100 flex-1">
                        <div style={{ flex: "2" }}>
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                            <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                        </div>
                        {/* <div className="col-4">
                                    
                                </div> */}
                        <Elements row={v.description} id={"description"} device={device} mode={mode} />
                    </div>
                </GridWrap>
            })
        }
        // listitem = <div className="menu-items">
        //     {listitem}
        // </div>
        listitem = <ListWrap data={data.elements.gallery} className="menu-items" grid={false} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }



    return <div className={`p-0 position-relative`}>
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <div className={`${app.isButton(data.elements.primaryButton, device)} ${app.isButton(data.elements.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                    <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                    <Elements row={data.elements.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                </div>
            </div>
        </div>
        <div className={data.properties.isFlipped ? `row flex-md-row-reverse flex-column-reverse` : `row`}>
            <div className="col-12 col-md-6">
                {listitem}
            </div>
            <div className="col-12 col-md-6">
                <Elements row={data.elements.banner} id={"banner"} device={device} mode={mode} />
            </div>
        </div>
    </div>
}

export const HomeTextGalleryOne = function ({ data, index, widgetType, mode, device }) {
    // return "Nitin"
    let listitem = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <div className="d-flex align-items-center">
                        <Elements row={v.icon} id={"icon"} device={device} mode={mode} />
                        <div className='mw-100'>
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                            <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                            <Elements row={v.description} id={"description"} device={device} mode={mode} />
                            <div style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                                <Elements row={v.primaryButton} id={"primaryButton"} device={device} mode={mode} />
                            </div>

                        </div>
                    </div>
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.gallery} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <Elements row={data.elements.description} id={"description"} device={device} mode={mode} />
                <div className={`${app.isButton(data.elements.primaryButton, device)} ${app.isButton(data.elements.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                    <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                    <Elements row={data.elements.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                </div>
            </div>
        </div>
        {listitem}
    </div>
}

export const HomeTextGalleryTwo = function ({ data, index, widgetType, mode, device }) {
    // console.log("HomeTextGalleryTwo", data)
    // return "Nitin"
    let listitem = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <Elements row={v.icon} id={"icon"} device={device} mode={mode} />
                    <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                    <Elements row={v.headingLabel} id={"headingLabel"} device={device} mode={mode} />
                    <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                    <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                    <Elements row={v.description} id={"description"} device={device} mode={mode} />
                    <Elements row={v.subDescription} id={"subDescription"} device={device} mode={mode} />
                    <Elements row={v.socialInfo} id={"socialInfo"} device={device} mode={mode} />
                    <div className={`d-flex align-items-start justify-content-${v.subDescription.properties.textAlignment}`}>
                        <Elements row={v.userBanner} id={"userBanner"} device={device} classType="w-auto" mode={mode} />
                        <Elements row={v.userDescription} id={"userDescription"} device={device} mode={mode} />
                    </div>
                    <div style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                        <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="ms-0" mode={mode} />
                    </div>

                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.gallery} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <Elements row={data.elements.description} id={"description"} device={device} mode={mode} />
                <div className={`${app.isButton(data.elements.primaryButton, device)} ${app.isButton(data.elements.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                    <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                    <Elements row={data.elements.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                </div>
            </div>
        </div>
        {listitem}
    </div>
}

export const HomeQuoteOne = function ({ data, index, widgetType, mode, device }) {
    // console.log("HomeQuoteOne", data)
    let listitem = ""
    if (data.elements.swiper) {
        if (data.elements.swiper.items) {
            listitem = data.elements.swiper.items.map(function (v, i) {
                return <GridWrap swiper={data.elements.swiper.properties.isSwiper}  data={v} key={'key-' + v.viewId + i} id="swiper" mode={mode} device={device}>
                    <div className={v.properties.isFlipped ? `row flex-md-row-reverse flex-column-reverse` : `row`}>
                        <div className="col-12 col-md-4">
                            <Elements row={v.headingLabel} id={"headingLabel"} device={device} mode={mode} />
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                            <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                            <div className={`${app.isButton(v.primaryButton, device)} ${app.isButton(v.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                                <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                                <Elements row={v.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                            </div>
                        </div>
                        <div className="col-12 col-md-8">
                            <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                        </div>
                    </div>
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.swiper} grid={false} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        {listitem}
    </div>
}


export const HomeIntroductionThree = function ({ data, index, widgetType, mode, device }) {
    let listitem = ""
    if (data.elements.swiper) {
        if (data.elements.swiper.items) {
            listitem = data.elements.swiper.items.map(function (v, i) {
                return <GridWrap swiper={data.elements.swiper.properties.isSwiper} data={v} key={'key-' + v.viewId + i} id="swiper" mode={mode} device={device}>
                    <div className="row">
                        <div className="col-12 col-md-12">
                            <Elements row={v.footerHeading} id={"footerHeading"} device={device} mode={mode} />
                            <Elements row={v.footerSummary} id={"footerSummary"} device={device} mode={mode} />
                        </div>
                    </div>
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.swiper} grid={false} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
            </div>
        </div>
        {listitem}
    </div>
}

export const HomeIntroduction = function ({ data, index, widgetType, mode, device }) {
    let listitem = ""
    if (data.elements.swiper) {
        if (data.elements.swiper.items) {
            listitem = data.elements.swiper.items.map(function (v, i) {
                return <GridWrap swiper={data.elements.swiper.properties.isSwiper} className="d-flex align-items-center justify-content-center" data={v} key={'key-' + v.viewId + i} id="swiper" mode={mode} device={device}>
                    <div className="row mw-100">
                        <div className="col-12 col-md-12">
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                            <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                            <div className={`${app.isButton(v.primaryButton, device)} ${app.isButton(v.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                                <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                                <Elements row={v.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                            </div>
                        </div>
                    </div>
                </GridWrap>
            })
        }

        listitem = <ListWrap data={data.elements.swiper} grid={false} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        {listitem}
    </div>
}

export const HomeIntroductionTwo = function ({ data, index, widgetType, mode, device }) {
    // console.log("HomeIntroductionTwo", data, index, widgetType, mode, device) 
    let listitem = ""
    if (data.elements.swiper) {
        if (data.elements.swiper.items && data.elements.swiper.items.length) {
            listitem = data.elements.swiper.items.map(function (v, i) {
                // let btn1 = app.isButton();
                return <GridWrap swiper={data.elements.swiper.properties.isSwiper} className={data.elements.swiper.properties.isSwiper?`h-100`:null} data={v} key={'key-' + v.viewId + i} id="swiper" mode={mode} device={device}>
                    <div className={v.properties.isFlipped ? `row flex-md-row-reverse flex-column-reverse` : `row`}>
                        <div className="col-12 col-md-7 d-flex align-items-center">
                            <div className='mw-100'>
                                <Elements row={v.headingLabel} id={"headingLabel"} device={device} mode={mode} />
                                <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                                <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                                <div className={`${app.isButton(v.primaryButton, device)} ${app.isButton(v.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                                    <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                                    <Elements row={v.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-5">
                            {/* {console.log("v.banner", v.banner)} */}
                            <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                        </div>
                    </div>
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.swiper} className="h-auto" mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        {listitem}
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.footerSummary} id={"footerSummary"} device={device} mode={mode} />
            </div>
        </div>
    </div>
}

export const HomePhotoGallery = function ({ data, index, widgetType, mode, device }) {
    // console.log("HomePhotoGallery", data)
    let swiperList = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            swiperList = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <div className=" p-0">
                        <Elements row={v.icon} id={"icon"} device={device} mode={mode} />
                        <Elements row={v.bannerLabel} id={"bannerLabel"} device={device} mode={mode} />
                        <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                        <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                        <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                        <Elements row={v.description} id={"description"} device={device} mode={mode} />
                        <Elements row={v.subDescription} id={"subDescription"} device={device} mode={mode} />
                        <Elements row={v.footerHeading} id={"footerHeading"} device={device} mode={mode} />
                        <Elements row={v.socialInfo} id={"socialInfo"} device={device} mode={mode} />
                    </div>
                </GridWrap>
            })
        }
        // swiperList = <div className={`row row-cols-${data.elements.gallery.properties.span} row-cols-lg-${data.elements.gallery.properties.spanWeb} g-4 align-items-start justify-content-center`}>
        //     {swiperList}
        // </div>
        swiperList = <ListWrap data={data.elements.gallery} mode={mode} device={device} index={index}>
            {swiperList}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <div className={`${app.isButton(data.elements.primaryButton, device)} ${app.isButton(data.elements.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                    <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                    <Elements row={data.elements.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                </div>
            </div>
        </div>

        {swiperList}
    </div>


}


export const HomeCardList = function ({ data, index, widgetType, mode, device }) {
    // console.log("HomeTextGalleryTwo", data)
    // return "Nitin"
    let listitem = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <Elements row={v.icon} id={"icon"} device={device} mode={mode} />
                    <div className='position-relative'>
                        <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                        <div className='position-absolute start-0 top-0 z-index-1'>
                            <Elements row={v.bannerLabel} id={"bannerLabel"} device={device} mode={mode} />
                        </div>
                        <div className='position-absolute start-50 bottom-0 translate-middle-x mb-n3  z-index-1' style={{ zIndex: '1' }}>
                            <Elements row={v.bannerInfo} id={"bannerInfo"} device={device} mode={mode} />
                        </div>
                        <div className='position-absolute end-0 bottom-0  z-index-1' style={{ marginBottom: '-30px' }}>
                            <Elements row={v.subInfo} id={"subInfo"} device={device} mode={mode} />
                        </div>

                    </div>
                    <Elements row={v.headingLabel} id={"headingLabel"} device={device} mode={mode} />
                    <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                    <div className='d-flex flex-1'>
                        <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                        <Elements row={v.description} id={"description"} device={device} mode={mode} />
                    </div>
                    <Elements row={v.subDescription} id={"subDescription"} device={device} mode={mode} />
                    <Elements row={v.socialInfo} id={"socialInfo"} device={device} mode={mode} />

                    <div className={`${app.isButton(v.primaryButton, device)} ${app.isButton(v.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                        <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                        <Elements row={v.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                    </div>

                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.gallery} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <Elements row={data.elements.description} id={"description"} device={device} mode={mode} />

                <div className={`${app.isButton(data.elements.primaryButton, device)} ${app.isButton(data.elements.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                    <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                    <Elements row={data.elements.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                </div>
            </div>
        </div>
        {listitem}
    </div>
}

export const HomeEventList = function ({ data, index, widgetType, mode, device }) {
    // console.log("HomeTextGalleryTwo", data)
    // return "Nitin"
    let listitem = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                    <div className='d-flex'>
                        <Elements row={v.headingLabel} id={"headingLabel"} device={device} classType="lh-1" mode={mode} />
                        <div className='flex-grow-1' style={{ width: "120px" }}>
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                            <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                            <Elements row={v.description} id={"description"} device={device} mode={mode} />
                        </div>
                    </div>
                    <Elements row={v.subDescription} id={"subDescription"} device={device} mode={mode} />
                    <Elements row={v.socialInfo} id={"socialInfo"} device={device} mode={mode} />
                    <div className={`${app.isButton(v.primaryButton, device)} ${app.isButton(v.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                        <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                        <Elements row={v.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                    </div>

                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.gallery} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <Elements row={data.elements.description} id={"description"} device={device} mode={mode} />
                <div className={`${app.isButton(data.elements.primaryButton, device)} ${app.isButton(data.elements.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                    <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                    <Elements row={data.elements.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                </div>
            </div>
        </div>
        {listitem}
    </div>
}


export const HomeBusinessHours = function ({ data, index, widgetType, mode, device }) {
    // console.log("BusinessHours", data)
    let listitem = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <div className='d-flex'>
                        <Elements row={v.day} id={"day"} device={device} classType="flex-1" mode={mode} />
                        <Elements row={v.duration} id={"duration"} device={device} classType="flex-1" mode={mode} />
                    </div>

                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.gallery} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }
    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.headingLabel} id={"headingLabel"} device={device} mode={mode} />
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <Elements row={data.elements.description} id={"description"} device={device} mode={mode} />
                <Elements row={data.elements.subDescription} id={"subDescription"} device={device} mode={mode} />
                <Elements row={data.elements.HoursTitle} id={"HoursTitle"} device={device} mode={mode} />
                {listitem}

            </div>
        </div>
    </div>
}

 
export const CenterAiBanner = function ({ data, index, widgetType, mode, device }) {
    
    const zoomStyleRef = useRef(null);
    useEffect(() => { 
        const loadSize = () => { 
            let domEle = document;
            if (document.querySelector("#iframe")) {
                if (document.querySelector("#iframe").contentWindow) {
                    domEle = document.querySelector("#iframe").contentWindow.document;
                }else{
                    domEle = document
                }
            } 
            let w = domEle.body.clientWidth;
            
            const zoomStyle = zoomStyleRef.current;
            if (zoomStyle) {
                zoomStyle.innerHTML = `
                [widget-type="centerAiBanner"] .mainCenterAi {
                    transform: translate(-50%, -50%) scale(${1 + ((w - 1008) / 1008)});
                }
                `;
            }
        };
        
        window.addEventListener('resize', loadSize);
        setTimeout(loadSize, 1);  
        return () => {
            window.removeEventListener('resize', loadSize);
        };
    }, [mode, device]);

    let loader = null; 
    if (app.aiBanner(mode)) {
        if (window.updatePagesData) {
            // loader = (
            //     <div className="loader-centerAi">
            //         <div className="d-grid" style={{ justifyItems: "center" }}>
            //             <div className="spinner-border"></div>
            //             <div className='mt-2'>Loading</div>
            //         </div>
            //     </div>
            // );

            if (data.properties.background.indexOf("mediadirhub.com/ai-banners") !== -1) {
                loader = "";
            }
        }
    }

    return (
        <>
            <style id="zoom" ref={zoomStyleRef}></style>
            <img className="w-100" src="https://media.mediadirhub.com/images/image-7x5.png" />
            {loader}
            <div className={loader ? "container-fluid p-0 d-flex align-items-center justify-content-center mainCenterAi" : "mainCenterAi p-0 d-flex align-items-center justify-content-center"}>
               <div> 
                    <Elements row={data.elements.headingLabel} id={"headingLabel"} device={device} mode={mode} />
                    <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                    <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                    <div className={`${app.isButton(data.elements.primaryButton, device)} ${app.isButton(data.elements.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                        <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                        <Elements row={data.elements.secondaryButton} id={"secondaryButton"} device={device} classType="ms-2" mode={mode} />
                    </div>
                </div>
            </div>
        </>
    );
}




export const CartList = function ({ data, index, widgetType, mode, device }) {
    // return "Nitin"
    let listitem = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap swiper={data.elements.gallery.properties.isSwiper}  data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                    <Elements row={v.heading} id={"heading"} device={device} mode={mode} />
                    <Elements row={v.price} id={"price"} device={device} mode={mode} />
                    <Elements row={v.summary} id={"summary"} device={device} mode={mode} />
                    <div className={`${app.isButton(v.primaryButton, device)} ${app.isButton(v.secondaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(v.properties.marginWeb) } : { margin: app.elementPadding(v.properties.margin) }}>
                        <Elements row={v.primaryButton} id={"primaryButton"} device={device} classType="me-2" mode={mode} />
                    </div>

                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.gallery} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <div className={`${app.isButton(data.elements.primaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                    <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} mode={mode} />
                </div>
            </div>
        </div>
        {listitem}
    </div>
}

export const SponsorsList = function ({ data, index, widgetType, mode, device }) {
    // return "Nitin"
    let listitem = ""
    if (data.elements.gallery) {
        if (data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap swiper={data.elements.gallery.properties.isSwiper}  data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <Elements row={v.banner} id={"banner"} device={device} mode={mode} />
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.gallery} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
            </div>
        </div>
        {listitem}
    </div>
}

export const TableList = function ({ data, index, widgetType, mode, device }) {
    // return "Nitin"
    let listitem = "";
   
    if (data.elements.gallery) {
        let spanGrid = "";
        if(app.getDevice()){
            spanGrid = data.elements.gallery.properties.spanWeb;
          }else{
            spanGrid = data.elements.gallery.properties.span;
          } 
        
        if(data.elements.gallery.items) {
            listitem = data.elements.gallery.items.map(function (v, i) {
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="gallery" mode={mode} device={device}>
                    <ul class="list-group list-group-horizontal border-0 flex-1 d-table w-100 table_data">
                        {Object.keys(v).slice(0, spanGrid).map((key, index) => (
                            <Elements row={v[key]} id={key} device={device} mode={mode} classType="list-group-item border-0" key={key + index} />
                        ))}
                        {/* <Elements row={v.item1} id={"item1"} device={device} mode={mode} classType="list-group-item border-0" />
                        <Elements row={v.item2} id={"item2"} device={device} mode={mode} classType="list-group-item border-0" />
                        <Elements row={v.item3} id={"item3"} device={device} mode={mode} classType="list-group-item border-0" />
                        <Elements row={v.item4} id={"item4"} device={device} mode={mode} classType="list-group-item border-0" />
                        <Elements row={v.item5} id={"item5"} device={device} mode={mode} classType="list-group-item border-0" /> */}
                    </ul>
                </GridWrap>
            })
        }
        listitem = <ListWrap data={data.elements.gallery} mode={mode} device={device} index={index} grid={false} className={`tableSpan-${data.elements.gallery.properties.span} tableSpanWeb-${data.elements.gallery.properties.spanWeb}`}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
        <div className={data.properties.isFlipped ? `row flex-md-row-reverse flex-column-reverse` : `row`}>
            <div className="col-12 col-md-5">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                <div className={`${app.isButton(data.elements.primaryButton, device)}`} style={device === "desktop" ? { margin: app.elementPadding(data.properties.marginWeb) } : { margin: app.elementPadding(data.properties.margin) }}>
                    <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} mode={mode} />
                </div>
            </div>
            <div className={!data.elements.heading.properties.showWeb && !data.elements.summary.properties.showWeb && !data.elements.primaryButton.properties.showWeb ? `col-12 col-md-12` : `col-12 col-md-7`}>
                {listitem}
            </div>
        </div>

    </div>
}